import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type DocumentIndicatorsFetchFailedAction = {
	type: 'DOCUMENT_INDICATORS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): DocumentIndicatorsFetchFailedAction => ({
	type: 'DOCUMENT_INDICATORS_FETCH_FAILED',
	payload,
});
